import { MachinesListDataTypes } from "@common/types/machines-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getVPNSupportSessionsUseCase = async (params?: {
  [key: string]: string;
}): Promise<{
  success: boolean;
  data: Record<string, MachinesListDataTypes[]>;
  error?: string;
}> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;

    const data = await apiUseCases.getVPNSupportSessions(namespace, params);

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      data: {},
      error: parseAxiosApiError(error, "Failed to fetch support sessions.")
        .message,
    };
  }
};
